// Module
var code = `<div class="assets-panel">
    <div class="assets-panel-container-top" {{#if !.accountSelectorVisible}}style="display: none;"{{/if}}>
        <accountSelector name="accountSelector" selectedItem="{{account}}" isMultiSelectMode="true"  visible="{{.accountSelectorVisible}}"/>
    </div>

    <div class="assets-panel-container-table">
        <terceraLabel name="noDataLabel"
                      text="{{.noAssetsAvailableText}}"
                      visible="{{.noDataLabelVisible}}"
                      additionalClass="js-tercera-label-transparentBG" />

        <terceraPanel name='windowPanelBodyQT' />
    </div>
</div>`;
// Exports
export default code;